import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import MessageBox from "../../../components/MessageBox/MessageBox";
import {
  get_cookies,
  getBranchidno,
} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
    maxHeight: "100%",
    overflow: "auto",
  },
  root: {
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },
}));

export default function MyAccount(props) {
  const { openMyAccount, setOpenMyAccount } = props;

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [positionData, setPositionData] = useState([]);
  const [branchIdData, setBranchIdData] = useState([]);
  const [userData, setUserData] = useState([]);

  // const [positionId, setPositionId] = useState(user_details.position_id);
  // const [positionIndex, setPositionIndex] = useState(null);
  // const [branchIdNoIndex, setBranchIdNoIndex] = useState(null);
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [lname, setLname] = useState("");
  const [username, setUsername] = useState("");
  const [branchidno, setBranchidno] = useState(getBranchidno);
  const [oldPassword, setOldPassword] = useState(null);
  const [password, setPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [strengthColor, setStrengthColor] = useState("");
  const [strengthColor_c, setStrengthColor_c] = useState("");
  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordStrength_c, setPasswordStrength_c] = useState("");
  //Message Box EOF
  const [btnDisabled, setBtnDisabled] = useState(true);

  const handleOpen = () => {
    //getUserData();
    setOpen(true);
  };

  const handleClose = () => {
    setOpenMyAccount(false);
    setOpen(false);
  };
  const checkPasswordStrength = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return { strength: "Password is too short", color: "red" };
    }
    const strengthCriteria = [
      hasUpperCase,
      hasLowerCase,
      hasNumbers,
      hasSpecialChar,
    ].filter(Boolean).length;

    switch (strengthCriteria) {
      case 4:
        return { strength: "Strong password", color: "green" };
      case 3:
        return { strength: "Medium password", color: "orange" };
      case 2:
        return { strength: "Weak password", color: "red" };
      default:
        return { strength: "Very weak password", color: "red" };
    }
  };
  const checkPasswordStrength_c = (password) => {
    const minLength = 8;
    const match = password;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return { strength: "Password is too short", color: "red" };
    }
    if (match != newPassword) {
      return { strength: "Confirm password does not match", color: "red" };
    }
    const strengthCriteria = [
      hasUpperCase,
      hasLowerCase,
      hasNumbers,
      hasSpecialChar,
    ].filter(Boolean).length;

    switch (strengthCriteria) {
      case 4:
        return { strength: "Strong password", color: "green" };
      case 3:
        return { strength: "Medium password", color: "orange" };
      case 2:
        return { strength: "Weak password", color: "red" };
      default:
        return { strength: "Very weak password", color: "red" };
    }
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setNewPassword(newPassword);
    const { strength, color } = checkPasswordStrength(newPassword);
    setPasswordStrength(strength);
    setStrengthColor(color);
  };

  const handlePasswordChange_old = (event) => {
    const newPassword = event.target.value;
    setOldPassword(newPassword);
  };
  const handlePasswordChange_c = (event) => {
    const newPassword = event.target.value;
    setConfirmPassword(newPassword);
    const { strength, color } = checkPasswordStrength_c(newPassword);
    setPasswordStrength_c(strength);
    setStrengthColor_c(color);
  };

  const setUserDetails = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_single_system_user", {
        params: {
          user_id: get_cookies("user_id"),
        },
      })
      .then(function (res) {
        setLname(res.data.data.user_lname);
        setMname(res.data.data.user_mname);
        setFname(res.data.data.user_fname);
        setUsername(res.data.data.username);
        //console.log(res.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  useEffect(() => {
    //
    setUserDetails();
    if (openMyAccount) {
      setOpen(true);
    }
  }, [openMyAccount]);

  useEffect(() => {
    if (password) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [password]);

  const showModal = (message, type) => {
    setShowMsgBox(true);
    setMsgType(type); //success or warning
    setMsg(message);
    setTimeout(() => {
      setShowMsgBox(false);
//       handleClose();
    }, 2000);
  };

  const editUserPassword = async () => {
    const formData = new FormData();
    formData.append("user_id", get_cookies("user_id"));
    formData.append("password", confirmPassword);
    formData.append("oldPassword", oldPassword);
    formData.append("username", get_cookies("username"));
    await axios
      .post(
        process.env.REACT_APP_API_URL + "edit_system_user_password",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (res) {
        console.log("re", res);
        if (res.data.status == 0) {
          showModal(res.data.message, "error");
        } else {
          showModal(
            "Updated Password. New Password will apply next login.",
            "success"
          );
	  setOldPassword('');
	  setNewPassword('');
	  setConfirmPassword('');
	  setPassword('');
        }
      })
      .catch(function (error) {
        showModal("Something went wrong " + error.message, "warning");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //editSystemUser();
  };

  const handleClickShowPassword = (flag) => {
    if (flag === "password") {
      setShowPassword(!showPassword);
    } else if (flag === "confirm") {
      setShowConfirmPassword(!showConfirmPassword);
    } else if (flag === "new") {
      setShowOldPassword(!showOldPassword);
    }
  };

  const validateUsername = (username) => {
    let isValidName = username.match(/^(([a-z])+([0-9])+|([a-z])+)/);
    if (!isValidName) {
      setUsername("");
      setShowMsgBox(true);
      setMsgType("warning"); //success or warning
      setMsg("Invalid Username");
      setTimeout(() => {
        setShowMsgBox(false);
      }, 2000);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      {/* <Button variant="contained" color="primary" onClick={handleOpen}>
				Edit
			</Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />
            <h2 id="transition-modal-title">My Account</h2>
            {open ? (
              <form onSubmit={handleSubmit} className={classes.root}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <TextField
                      id="outlined-basic"
                      style={{ marginTop: "16px" }}
                      label="User Name"
                      variant="outlined"
                      placeholder="User Name"
                      inputProps={{ "aria-label": "User Name", readOnly: true }}
                      value={get_cookies("username")}
                      onChange={(e) => setUsername(e.target.value)}
                      onBlur={(e) => {
                        validateUsername(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <TextField
                      id="outlined-basic"
                      style={{ marginTop: "16px" }}
                      label="Branch"
                      variant="outlined"
                      placeholder="Branch"
                      inputProps={{ "aria-label": "User Name", readOnly: true }}
                      value={branchidno}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <TextField
                      id="outlined-basic"
                      label="User role"
                      variant="outlined"
                      style={{ marginTop: "21px" }}
                      placeholder="User role"
                      fullWidth={true}
                      inputProps={{
                        "aria-label": "User role",
                        readOnly: true,
                      }}
                      value={get_cookies("userrole")}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <TextField
                      id="outlined-basic"
                      label="Full Name"
                      variant="outlined"
                      style={{ marginTop: "21px" }}
                      placeholder="Full Name"
                      fullWidth={true}
                      inputProps={{
                        "aria-label": "Full Name",
                        readOnly: true,
                      }}
                      value={get_cookies("fullname")}
                    />
                  </Grid>
		  <Grid item xs={12} md={12} lg={12} xl={12}>
		  <h3 id="transition-modal-title">Change Password</h3>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <InputLabel htmlFor="outlined-adornment-password">
                      Old Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showOldPassword ? "text" : "password"}
                      value={oldPassword}
                      fullWidth={true}
                      onChange={handlePasswordChange_old}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              handleClickShowPassword("new");
                            }}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showOldPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={50}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <InputLabel htmlFor="outlined-adornment-password">
                	New Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      fullWidth={true}
                      onChange={handlePasswordChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              handleClickShowPassword("password");
                            }}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={50}
                    />

                    <p style={{ color: strengthColor }}>
                      Password Strength: {passwordStrength}
                    </p>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <InputLabel htmlFor="outlined-adornment-password">
                      Confirm Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      fullWidth={true}
                      onChange={handlePasswordChange_c}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              handleClickShowPassword("confirm");
                            }}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={50}
                    />

                    <p style={{ color: strengthColor_c }}>
                      Password Strength: {passwordStrength_c}
                    </p>
                    <ul>
                      <li>Password must be at least 8 characters long.</li>
                      <li>Include at least one uppercase letter (A-Z).</li>
                      <li>Include at least one lowercase letter (a-z).</li>
                      <li>Include at least one number (0-9).</li>
                      <li>
                        Include at least one special character (e.g., !@#$%^&*).
                      </li>
                    </ul>
                  </Grid>

                  {/* <Grid item xs={12} md={4} lg={4} xl={4}>
                    <TextField
                      id="outlined-basic"
                      label="Middle Name"
                      variant="outlined"
                      style={{ marginTop: "21px" }}
                      fullWidth={true}
                      placeholder="Middle Name"
                      inputProps={{
                        "aria-label": "Middle Name",
                        readOnly: true,
                      }}
                      value={mname}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4} xl={4}>
                    <TextField
                      id="outlined-basic"
                      label="Last Name"
                      variant="outlined"
                      style={{ marginTop: "21px" }}
                      fullWidth={true}
                      placeholder="Last Name"
                      inputProps={{ "aria-label": "Last Name", readOnly: true }}
                      value={lname}
                    />
                  </Grid> */}
                </Grid>
                <div className={classes.button}>
                  <Button
                    variant="contained"
                    onClick={handleClose}
                    className={classes.buttonMarginRight}
                  >
                    Close
                  </Button>
                  <Button
                    type="submit"
                    disabled={passwordStrength !== "Strong password"}
                    onClick={() => {
                      editUserPassword();
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Change Password
                  </Button>
                </div>
              </form>
            ) : (
              <div></div>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
